module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "epigraph1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page-ix"
    }
  }), _c('em', [_vm._v("We know many things about those we love—things we nevertheless refuse to believe.")])]), _vm._v(" "), _c('p', {
    staticClass: "attribution1"
  }, [_vm._v("—E"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("LIAS")]), _vm._v(" C"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ANETTI")])])]), _vm._v(" "), _c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Mother is the best bet and don’t let Satan draw you too fast.")])]), _vm._v(" "), _c('p', {
    staticClass: "attribution1"
  }, [_vm._v("—D"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("UTCH")]), _vm._v(" S"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("CHULTZ")]), _vm._v(", on his deathbed")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08274547","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/epigraph.vue
// module id = 69
// module chunks = 0